export const invitationActionTypes = {
  SET_INVITATION_DATA: 'user/SET_INVITATION_DATA',
};
